import { render, staticRenderFns } from "./taskHistory.vue?vue&type=template&id=08d3c394&scoped=true&"
import script from "./taskHistory.vue?vue&type=script&lang=js&"
export * from "./taskHistory.vue?vue&type=script&lang=js&"
import style0 from "./taskHistory.vue?vue&type=style&index=0&id=08d3c394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d3c394",
  null
  
)

export default component.exports